import { axiosPut, axiosGet, axiosPost, axiosGetblob } from '../axios/httpRequest';

/**
 * 查询来访申请记录
 */
export const getVistRecordListApi = params => {
    return axiosGet('api/check_in_record/v1/vist_registration', params);
};

/**
 * 后台查询入住记录分页
 */
export const getCheckInRecordListApi = params => {
    return axiosGet('api/check_in_record/v1/check_in_record', params);
};

/**
 * 微信端根据身份证查询入住人员信息
 */
export const getUserByIdNoApi = params => {
    return axiosGet('api/check_in_record/v1/check_in_record/visit', params);
};

/**
 * 来访登记
 */
export const postRegistrationApi = params => {
    return axiosPost('api/check_in_record/v1/vist_registration', params);
};

/**
 * 导出申请记录
 */
export const getDownloadApi = params => {
    return axiosGetblob('api/check_in_record/v1/vist_registration/download', params);
};

/**
 * 修改入住情况
 */
export const updateCheckInRecord = params => {
    return axiosPut(`api/check_in_record/v1/check_in_record/${params.id}`, params);
};

/**
 *  通过短信验证码登录
 * @param  params
 * @returns
 */
export const loginBySmsApi = params => {
    return axiosPost(`/api/auht/v1/login/sms`, params);
};

/**
 * 发送短信验证码
 * @param  params
 * @returns
 */
export const sendSmsApi = params => {
    return axiosPost(`/api/auht/v1/sms/code`, params);
};

export const sendSmsApiByUserName = params => {
    return axiosPost('api/auht/v1/sms/code/username', params);
};

/**
 * 获取探访记录
 * @param {} params
 */
export const getVisitRecordApi = params => {
    return axiosGet(`/api/check_in_record/v1/vist_registration/user`, params);
};

/**
 * 修改来访信息
 */
export const updateVisitApi = params => {
    return axiosPut(`/api/check_in_record/v1/vist_registration/${params.id}`, params);
};

export const fastCheckInApi = params => {
    return axiosPost(`/api/check_in_record/v1/fast`, params);
};

export const getDownloadCheckApi = params => {
    return axiosGetblob('api/check_in_record/v1/download', params);
};

/**
 * 时间统计
 */
export const getStatics = params => {
    return axiosGet('/api/check_in_record/statics', params);
};

export const getDownloadStaticsCheckApi = params => {
    return axiosGetblob('api/check_in_record/statics/v1/download', params);
};

export const sendSmsApiById = params => {
    return axiosPost('api/auht/v1/sms/code/idNo', params);
};

export const sendSmsApiByIdAndNo = params => {
    return axiosPost('api/auht/v1/sms/code/idNoAndPhone', params);
};

export const getIdenStatics = params => {
    return axiosGet('/api/check_in_record/staticsByIdentity', params);
};

/**
 * 条件统计查询
 */
export const getConditionStatisticsList = params => {
    return axiosGet('/api/check_in_record/conditionStatistics', params);
};

/**
 * 导出条件统计记录
 */
export const getDownloadConditionStatisticsApi = params => {
    return axiosGetblob('/api/check_in_record/conditionStatistics/download', params);
};
